// src/pages/ServiciosPenales.jsx
import React from 'react';
import LegalCard from '../components/LegalCard'; // Reutilizás el mismo componente

import {
  FaGavel, FaShieldAlt, FaBalanceScale,
   FaBriefcase, FaHeartbeat, FaBuilding, FaAddressBook
} from 'react-icons/fa';

const ServiciosPenales = () => {
  const servicios = [
    {
      icon: <FaGavel />,
      title: 'Defensa en investigación penal preparatoria',
      description: 'Asistencia legal desde los primeros actos de investigación, declaraciones, diligencias probatorias y estrategias preventivas.'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Ejecución penal',
      description: 'Cómputos de pena, salidas transitorias, libertad asistida, prisión domiciliaria, hábeas corpus.'
    },
    {
      icon: <FaBalanceScale />,
      title: 'Interposición de recursos',
      description: 'Apelaciones, casaciones y recursos extraordinarios con argumentación jurídica precisa y actualizada.'
    },
    {
      icon: <FaGavel />,
      title: 'Juicio oral y público',
      description: 'Defensa en control de la prueba, interrogatorios y alegatos orales.'
    },
    {
      icon: <FaBriefcase />,
      title: 'Defensa penal para personas extranjeras',
      description: 'Asesoramiento a personas extranjeras sometidas a proceso penal en Córdoba.'
    },
    {
      icon: <FaHeartbeat />,
      title: 'Asistencia en causas federales y provinciales.',
      description: 'Representación con enfoque técnico y respeto a los derechos humanos.'
    },
    {
      icon: <FaBuilding />,
      title: 'Expulsión de extranjeros',
      description: 'Tramitación judicial y administrativa de medidas de expulsión, centrado en derechos fundamentales.'
    },
    {
      icon: <FaAddressBook />,
      title: 'Derecho penal juvenil',
      description: 'Defensa penal especializada para jóvenes, con enfoque en derechos, educación y reinserción.'
    }
  ];

  return (
    <div className="cards-container">
      
      <div className="cards-container">
      {servicios.map((card, index) => (
        <LegalCard
        key={index}
        icon={card.icon}
        title={card.title}
        description={card.description}
        link={card.link}
        />
      ))}
      </div>

    </div>
  );
};

export default ServiciosPenales;
